<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'StaticModal',
  props:[
    "list"
  ],
  data() {
    return {
      options: [],
      form: { content:'' },
      submitted: false,
    };
  },
  validations: {
    form: {
      content: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  filters:{
    strpad(data){
      return data.toString().padStart(2, "0");
    },
    _replace(data,arg){
       if(!data) return
        return data.replace('{trigera}', arg.trigera).replace('{trigerb}', arg.trigerb);
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      this.submitted = false;
      if (this.$v.$invalid) return;
      this.update();
      
      this.$emit('loadItems');
    },
    update(){
      this.$http.put('/system-sms/' + this.form.id , this.form)
        .then(resp => {
          //this.form = { content:'' };
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    }
  },
};
</script>

<template>
  <b-modal id="modal-scoped" size="lg"  :title="form.title"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="content">Mesaj İçerik</label>
              <textarea spellcheck="false" class="form-control" rows="5" v-model="form.content"></textarea>
              <p style="margin-top:5px;text-align:right" class="text-muted">Metnin içerisindeki değişkenlere göre yaklaşık {{ form.content.length || 0 }} karakter</p>
              <div
                v-if="submitted && !$v.form.content.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
           <div class="col-12" v-if="form.trigera || form.trigerb">
                <div class="row">
                    <div class="col-6" v-if="form.trigera">
                        <div class="mb-3">
                            <label for="trigera">Gün</label>
                              <select
                                class="form-select"
                                id="trigerb"
                                v-model="form.trigera">
                               <option :value="index" v-for="index in 30" :key="index">{{ index }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-6" v-if="form.trigerb">
                        <div class="mb-3">
                            <label for="trigerb">Saat</label>
                            <select
                                class="form-select"
                                id="trigerb"
                                v-model="form.trigerb">
                               <option :value="index-=1 | strpad" v-for="index in 24" :key="index">{{ index-- | strpad }}</option>
                            </select>
                        </div>
                    </div>
                </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
                {{ form.description | _replace(form) }}
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <div class="form-check form-check-success mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="formsuccess"
                  checked=""
                  v-model="form.status"
                />
                <label class="form-check-label" for="formsuccess">
                  Aktif
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>